import React, { useEffect, useState } from "react";
import { InputBox, Password } from "../../components/CustomWidgets/InputBox";
import { useFormik } from "formik";
import SelectBox, { MultiSelectBox } from "../CustomWidgets/SelectBox";
import UploadMediaonly from "../upload-imageonly";
import {
  createStoreUser,
  updateStoreUser,
  UserImageUpload,
  sendPhoneOtp,
  verifyPhoneOtp,
  sendEmailOtp,
  verifyEmailOtp,
} from "../../API  Functions/UserMangement";
import "../../styles.css";
import UsermanagementPopup from "../../Popups/usermanagementPopup";
import VerifyContactOtp from "../../modals/VerifyContactOtp";
import { FaCheckCircle } from "react-icons/fa";
import { useSelector } from "react-redux";
import { addUserSchema } from "../validationSchema";
import { useTranslation } from "react-i18next";
import image from "../../assets/Images/roundimage.png";
import LoadingSpinner from "../Loading";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Input, Select } from "antd";
import FlagIcon from "../../assets/egypt.svg";
import { checkPermission } from "../../Utils/permissionHelper";
import { getSubstores } from "../../API  Functions/ProfileFunctions";
import i18next from "i18next";

const AddUser = ({ onClose, isEdit, subStores }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const userinfo = useSelector((state) => state?.login?.user?.result);

  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const companyId = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );
  const isGinne = useSelector((state) => state?.geneLoginReducer?.isGinneLogin);
  const staticUserTypes = [
    { id: 1, name: "Store User" },
    { id: 2, name: "Cashier User" },
  ];
  const masterStore = useSelector((state) => state.login.masterStore);
  const isWarehouse = useSelector(
    (state) => state?.login?.user?.result?.is_warehouse,
  );
  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store,
  );
  const contractType =
    useSelector((state) => state.login.contractType) || "Cashier_Ecom";
  const [storesAccess, setStoresAccess] = useState([]);

  const filteredUserTypes = staticUserTypes.filter((type) => {
    if (contractType === "Cashier_Ecom") return true; // show both
    if (contractType === "Cashier") return true; // Online POS only
    if (contractType === "Ecom") return type.id === 1; // Online Sale only
    return false;
  });
  // console.log("contractType==>", contractType);

  /* STEP 2: append Warehouse Manager condition */
  const userTypes = [
    ...(allStores
      ? [...staticUserTypes, { id: 3, name: "Warehouse Manager" }]
      : masterStore?.store_id === companyId
        ? staticUserTypes
        : isWarehouse === true
          ? [{ id: 3, name: "Warehouse Manager" }]
          : staticUserTypes),
  ];

  console.log("userTypes", userTypes);

  // const [userTypes, setuserTypes] = useState(staticUserTypes);
  const [popup, setpopup] = useState(false);
  const [message, setmessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [base64Images, setBase64Images] = useState([]);
  const [hasChanges, setHasChanges] = useState(false);
  const [isFileValid, setIsFileValid] = useState(false);
  const [loading, setLoading] = useState(false);

  const [selectedSubStore, setSelectedSubStore] = useState(null);

  const isMasterStore = useSelector(
    (state) => state?.login?.user?.result?.is_master_store,
  );

  // console.log("isMasterStore==>", masterStore);

  // console.log("AHAHAAHHA", isEdit);

  const [Error, setError] = useState(0);

  // Tracks the exact email/phone value that has already passed OTP verification.
  const [verifiedEmail, setVerifiedEmail] = useState("");
  const [verifiedPhone, setVerifiedPhone] = useState("");
  const [otpModal, setOtpModal] = useState(null); // "email" | "phone" | null

  useEffect(() => {
    if (isEdit?.store_id) {
      setSelectedSubStore(isEdit.store_id);
    } else {
      setSelectedSubStore(masterStore?.store_id);
    }
    setStoresAccess(isEdit?.store_ids?.map(e => e.store_id) ?? [])
    setVerifiedEmail(isEdit?.email ? isEdit.email.toLowerCase() : "");
    setVerifiedPhone(isEdit?.phone ? String(isEdit.phone).replace(/^0+/, "") : "");
  }, [isEdit]);

  const formik = useFormik({
  initialValues: {
  password: isEdit?.password || "",
  first_name: isEdit?.name ?? "",
  store_user_type_id:
    isEdit?.user_type === "online_sale" || isEdit?.user_type === "admin"
      ? 1
      : isEdit?.user_type === "online_pos"
      ? 2
      : isEdit?.user_type === "wh_manager"
      ? 3
      : "",
  email: isEdit?.email || "",
  phoneNumber: isEdit?.phone ? isEdit?.phone : "",
  username: isEdit?.username || "",
  url: isEdit?.image_url ?? "",
  is_dashboard_show: isEdit?.is_dashboard_show ?? false,
  is_password_restrict: isEdit?.is_password_restrict ?? false,
  pos_password: isEdit?.pos_password || "",
  show_orders: isEdit?.show_orders ?? false,
  show_credit: isEdit?.show_credit ?? false,
  is_show_cost_price : isEdit?.is_show_cost_price ?? false,
  is_show_total_credit: isEdit?.is_show_total_credit ?? true,
  store_ids: (isEdit?.user_type === "online_sale") ? isEdit?.store_ids?.map(e => e.store_id) ?? [] : []
},
    validationSchema: addUserSchema,
    onSubmit: async (values, { resetForm }) => {
      if (!checkPermission("/settings/usermanagement", isGinne)) {
        return;
      }
console.log("callded");

      // const normalizedEmailForSubmit = values.email?.toLowerCase() || "";
      // const normalizedPhoneForSubmit = values.phoneNumber?.replace(/^0+/, "") || "";

      // if ((verifiedEmail !== normalizedEmailForSubmit) && (verifiedPhone !== normalizedPhoneForSubmit)) {
      //   toast.error(t("please_verify_email_phone"));
      //   return;
      // }

      // if (verifiedEmail !== normalizedEmailForSubmit) {
      //   toast.error(t("please_verify_email"));
      //   return;
      // }
      // if (verifiedPhone !== normalizedPhoneForSubmit) {
      //   toast.error(t("please_verify_phone"));
      //   return;
      // }

      const apipayload = {
        user_id: user_id,
        retailer_user_id: isEdit?.retailer_user_id,
        user_type: isEdit?.user_type,
      };

      try {
        if (!isEdit) {
          console.log("base64Images", base64Images);

          // if (base64Images.length < 0 || base64Images.length === 0) {
          //   toast.error(t("Please upload user image."));
          //   return;
          // }
          // if (base64Images.length > 0) {
          //   formik.setFieldError("url", undefined);
          // }

          setLoading(true);

          const imageName = values.email.split("@")[0];
          let imageResponse = null;
          if (base64Images?.length > 0) {
            imageResponse = await UserImageUpload(base64Images, imageName);
          }

          // if (imageResponse) {
          formik.setFieldValue("url", imageResponse);

         const payload = {
  user_id: user_id,
  company_id: companyId,
  password: values.password,
  name: values.first_name,
  phone: values.phoneNumber?.replace(/^0+/, ""),
  username: values.username,
  user_type: values.store_user_type_id === 1
    ? "online_sale"
    : values.store_user_type_id === 2
    ? "online_pos"
    : "wh_manager",
  email: values.email.toLowerCase(),
  image_url: imageResponse,
  is_dashboard_show: true,
  show_orders: true,
  show_credit: true,
  is_password_restrict: false,
  is_favorite_show: true,
  is_all_categ_show: true,
  pos_password: "",
  sub_store_id: allStores ? selectedSubStore : false,
  is_allow_opening_cash: true,
  is_allow_add_product: true,
  is_allow_edit_product_group: true,
  is_show_cost_price : values?.is_show_cost_price ,
  is_allow_sale_price_edit: false,
  is_allow_bill_discount: false,
  is_tax_price_inclusive: false,
  store_ids: values.store_user_type_id === 1 ? storesAccess || [] : [],
};

          const res = await createStoreUser(payload);

          if (res?.data?.result?.status_code === 200) {
            setmessage("User  Created Successfully");
            setLoading(false);
            setIsSuccess(true);
            setpopup(true);
            resetForm();
            setStoresAccess([])
            setBase64Images([]);
            // navigate("/settings/usermanagement")
          } else if (
            res?.data?.result?.status === "User  Created Successfully"
          ) {
            setmessage("User  Created Successfully");
            setLoading(false);
            setIsSuccess(true);
            setpopup(true);
            resetForm();
            setStoresAccess([])
            setBase64Images([]);
          } else if (
            res?.data?.result?.status_code === 400 &&
            res?.data?.result?.status?.includes("You can not create a user")
          ) {
            setmessage(
              t("You cannot add more users. The user limit has been reached."),
            );
            setLoading(false);
            setIsSuccess(false);
            setpopup(true);
            resetForm();
            setStoresAccess([]);
            setBase64Images([]);
            // setError(1);
          }
          // else if (res?.data?.result?.status_code === 400) {
          //   toast.error(t(res?.data?.result?.status));
          //   setLoading(false);
          //   resetForm();
          //   setBase64Images([]);
          // }
          else if (res?.data?.result?.status_code === 400) {
            const backendMessage = res?.data?.result?.status || "";
            let errorMessage = t("Failed to process request"); // generic fallback

            // Pattern-based matching for known backend errors
            if (/maximum branch limit/i.test(backendMessage)) {
              errorMessage = t(
                "You cannot active a branch. The maximum branch limit has been reached.",
              );
            } else {
              // Try direct translation (in case backend returns a translatable key)
              errorMessage = t(backendMessage) || errorMessage;
            }

            toast.error(errorMessage);
            setLoading(false);
            resetForm();
            setBase64Images([]);
          }
        } else {
          setLoading(true);
          if (base64Images.length > 0) {
            const imageName = values.email.split("@")[0];
            setLoading(true);
            const imageResponse = await UserImageUpload(
              base64Images,
              imageName,
            );
            console.log("Image Response:", imageResponse);

            apipayload.image_url = imageResponse;
          }

       if (formik.values.first_name !== isEdit?.name) {
  apipayload.name = values.first_name;
}
if (formik.values.password) {
  apipayload.password = values.password;
}
if (formik.values.phoneNumber !== isEdit?.phone) {
  apipayload.phone = values.phoneNumber?.replace(/^0+/, "");
}
if (formik.values.username !== isEdit?.username) {
  apipayload.username = values.username;
}
if (formik.values.email.toLowerCase() !== isEdit?.email.toLowerCase()) {
  apipayload.email = values.email.toLowerCase();
}

          // if (
          //   formik.values.is_password_restrict !== isEdit?.is_password_restrict
          // ) {
          //   apipayload.is_password_restrict = values.is_password_restrict;
          // }
          if (formik.values.is_dashboard_show !== isEdit?.is_dashboard_show) {
            apipayload.is_dashboard_show = values.is_dashboard_show;
          }
          if (formik.values.show_orders !== isEdit?.show_orders) {
            apipayload.show_orders = values.show_orders;
          }
          if (formik.values.show_credit !== isEdit?.show_credit) {
            apipayload.show_credit = values.show_credit;
          }
          if (formik.values.pos_password !== isEdit?.pos_password) {
            apipayload.pos_password = values.pos_password;
          }
          // apipayload.is_restrict_invetory_update =
          //   values.is_restrict_invetory_update;
             apipayload.is_show_cost_price =
            values.is_show_cost_price;

          // if (values.is_restrict_invetory_update) {
          //   apipayload.inventory_password = values.inventory_password?.trim();
          // }
          if(storesAccess){
             apipayload.store_ids = isEdit?.user_type === "online_sale" ? storesAccess|| [] : [];
          }
          const res = await updateStoreUser(apipayload);
          console.log("Update Response:", res);

          if (res?.data?.result[0]?.status_code === 200) {
            setmessage("User Updated Successfully");
            setIsSuccess(true);
            setpopup(true);
            setLoading(false);
            // navigate("/settings/usermanagement")
          } else if (
            res?.data?.result[0]?.status ===
            "Please close the POS session for this user"
          ) {
            toast.error(t("Please close the POS session for this user"));
            setLoading(false);
          } else if (
            res?.data?.result[0]?.status_code === 400 &&
            res?.data?.result[0]?.status === "Email Duplicate"
          ) {
            // console.log("Update---- Response:");
            toast.error(t("Email already exist."));
            setLoading(false);
          } else {
            toast.error(t(res?.data?.result[0]?.status));
            setLoading(false);
          }
        }
      } catch (error) {
        console.error("Error during submission:", error);
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    if (isEdit && userTypes) {
      const userType = userTypes.find((item) => isEdit.user_type === item.name);
      if (userType) {
        formik.setFieldValue("store_user_type_id", userType.id);
      }
    }
    // if (!isEdit && contractType != "Cashier_Ecom") {
    //   formik.setFieldValue(
    //     "store_user_type_id",
    //     contractType === "ECom" ? 1 : 2
    //   );
    // }
  }, [isEdit, userTypes, contractType]);

  const getMaxLength = (mobile) => {
    return mobile?.startsWith("0") ? 11 : 10;
  };

  // const normalizedEmail = formik.values.email?.toLowerCase() || "";
  // const normalizedPhone = formik.values.phoneNumber?.replace(/^0+/, "") || "";
  // const isEmailVerified = !!normalizedEmail && verifiedEmail === normalizedEmail;
  // const isPhoneVerified = !!normalizedPhone && verifiedPhone === normalizedPhone;
  // const isValidEmailFormat = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val || "");

  // const handleSendOtp = async (type) => {
  //   if (type === "email") {
  //     if (!isValidEmailFormat(formik.values.email)) {
  //       formik.setFieldTouched("email", true);
  //       return;
  //     }
  //   } else {
  //     if (!/^\d{10,15}$/.test(normalizedPhone)) {
  //       formik.setFieldTouched("phoneNumber", true);
  //       return;
  //     }
  //   }

  //   try {
  //     setLoading(true);
  //     const res =
  //       type === "email"
  //         ? await sendEmailOtp({ email: normalizedEmail })
  //         : await sendPhoneOtp({
  //             new_mobile: normalizedPhone,
  //             country_code: "+20",
  //             hash_code: "",
  //           });

  //     if (!res?.data) {
  //       toast.error(t("Failed to process request"));
  //       return;
  //     }

  //     const result = res.data?.result;
  //     if (result?.status_code && result.status_code !== 200) {
  //       toast.error(t(result.status) || t("Failed to process request"));
  //       return;
  //     }

  //     toast.success(t("otp_sent_success"));
  //     setOtpModal(type);
  //   } catch (error) {
  //     toast.error(t("Failed to process request"));
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const handleResendOtp = async () => {
  //   if (!otpModal) return { success: false };
  //   const res =
  //     otpModal === "email"
  //       ? await sendEmailOtp({ email: normalizedEmail })
  //       : await sendPhoneOtp({
  //           new_mobile: normalizedPhone,
  //           country_code: "+20",
  //           hash_code: "",
  //         });

  //   if (!res?.data) return { success: false };
  //   const result = res.data?.result;
  //   if (result?.status_code && result.status_code !== 200) {
  //     toast.error(t(result.status) || t("Failed to process request"));
  //     return { success: false };
  //   }
  //   return { success: true };
  // };

  // const handleSubmitOtp = async (otp) => {
  //   const res =
  //     otpModal === "email"
  //       ? await verifyEmailOtp({ email: normalizedEmail, otp })
  //       : await verifyPhoneOtp({
  //           new_mobile: normalizedPhone,
  //           country_code: "+20",
  //           otp: Number(otp),
  //         });

  //   const result = res?.data?.result;
  //   const isSuccess =
  //     result?.status_code === 200 || /verif/i.test(result?.status || "");

  //   return { success: !!isSuccess };
  // };

  // const handleOtpVerified = () => {
  //   if (otpModal === "email") {
  //     setVerifiedEmail(normalizedEmail);
  //   } else if (otpModal === "phone") {
  //     setVerifiedPhone(normalizedPhone);
  //   }
  //   setOtpModal(null);
  //   toast.success(t("Verified"));
  // };

  // Ant Design's Select/MultiSelectBox swallow the Enter keydown for their own
  // dropdown navigation, which stops it from ever reaching the form's native
  // implicit-submission handling. Capture the key ourselves so Enter always
  // submits, except while a dropdown is actually open (there it should pick
  // the highlighted option instead).
  const handleFormKeyDown = (e) => {
    if (e.key !== "Enter") return;
    const target = e.target;
    if (target?.tagName === "TEXTAREA") return;
    const openDropdown = document.querySelector(
      ".ant-select-dropdown:not(.ant-select-dropdown-hidden), .ant-picker-dropdown:not(.ant-picker-dropdown-hidden)"
    );
    if (openDropdown) return;
    e.preventDefault();
    formik.handleSubmit();
  };

  // console.log("isEdit?.user_typ===>", formik.errors);

  return (
    <div className="z-50">
      {loading && <LoadingSpinner />}
      <form onSubmit={formik.handleSubmit} onKeyDownCapture={handleFormKeyDown}>
        <div className=" ">
          <div className="flex flex-col md:flex-row justify-between items-baseline">
            <div className="font-semibold text-md md:text-2xl mt-5">
              {isEdit ? t("edit_user") : t("Add User")}{" "}
            </div>
            <div className="flex gap-5 mt-4 md:mt-0 ">
              <button
                type="button"
                onClick={() => onClose()}
                className="w-36 h-10 bg-white text-primaryBlue font-semibold rounded-lg inline border border-primaryBlue"
              >
                {t("cancel")}
              </button>
              <button
                type="submit"
                className={`w-36 h-10 rounded-lg font-semibold ${
                  hasChanges
                    ? "bg-primaryBlue text-white"
                    : "bg-primaryBlue text-white opacity-50 cursor-not-allowed"
                }`}
                disabled={!hasChanges}
              >
                {t("save")}
              </button>
            </div>
          </div>
          <div className="md:w-full bg-[#FFFFFF] border rounded-xl mt-5">
            <div className="w-full h-10 bg-[#C9ECF7] px-4  flex items-center font-medium text-base rounded-tr-xl rounded-tl-xl text-[#272728]">
              {t("basic_details")}
            </div>
            <div className="flex flex-col md:flex-row justify-center items-start mt-4 gap-x-8 px-6 pb-6 md:pb-28">
              <div
                className={`w-72 md:w-44 h-52 flex flex-col overflow-hidden ${
                  formik.values?.url == ""
                    ? "rounded-lg border border-gray-900/25 bg-[#ffffff]"
                    : "rounded-full"
                } relative ${
                  formik.errors.url && formik.touched.url ? "border-red" : ""
                }`}
              >
                <label
                  for="file-upload"
                  class=" items-center relative cursor-pointer rounded-md bg-white font-semibold text-primaryBlue  hover:text-primaryBlue"
                >
                  <div className={`flex h-10 items-center justify-center`}>
                    {isEdit ? (
                      base64Images.length > 0 ? (
                        <img
                          className="w-[8rem] h-[7rem] object-contain mt-24"
                          src={base64Images}
                          width={60}
                          height={60}
                          alt="store user"
                        />
                      ) : formik.values.url ? (
                        <img
                          className="w-[8rem] h-[7rem] object-cover rounded-full mt-24"
                          src={formik.values.url}
                          width={100}
                          height={100}
                          alt="store user"
                        />
                      ) : (
                        <img
                          className="w-[8rem] h-[7rem] object-contain mt-24"
                          src={image}
                          width={60}
                          height={60}
                          alt="store user"
                        />
                      )
                    ) : formik.values.url ? (
                      <img
                        className="w-[8rem] h-[7rem] object-cover rounded-full mt-24"
                        src={formik.values.url}
                        width={100}
                        height={100}
                        alt="store user"
                      />
                    ) : base64Images.length > 0 ? (
                      <img
                        className="w-[8rem] h-[7rem] object-cover rounded-full mt-24"
                        src={base64Images}
                        width={60}
                        height={60}
                        alt="store user"
                      />
                    ) : (
                      <img
                        className="w-[8rem] h-[7rem] object-contain mt-24"
                        src={image}
                        width={60}
                        height={60}
                        alt="store user"
                      />
                    )}
                  </div>
                  <div className="mt-[5.9rem] bottom-0">
                    <UploadMediaonly
                      foldername={"store_app_UAT"}
                      onfileAdd={`storeuserurl`}
                      setIsFileValid={setIsFileValid}
                      setBase64Images={(images) => {
                        setBase64Images(images);
                        setHasChanges(true);
                      }}
                      urlgenerated={(val) => {
                        formik.setFieldValue("url", val.url);
                      }}
                      imageurl={formik.values.url}
                    />
                  </div>
                </label>
              </div>
              <div className="font-normal text-sm text-[#5C5C5C] flex flex-col md:flex-row md:gap-6 w-full">
                <div className="w-full flex flex-col gap-4 leading-[0px]">
                  <label style={{ marginBottom: -15, marginTop: 15 }}>
                    {t("Name")}
                  </label>
                  <InputBox
                    name="first_name"
                    placeholder={t("Enter Name")}
                    onChange={(e) => {
                      formik.handleChange(e);
                      setHasChanges(true);
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.first_name}
                    touched={formik.touched.first_name}
                    error={formik.errors.first_name}
                    // disabled={isEdit?.user_type === "admin"}
                  />

                  {isEdit?.user_type !== "admin" && (
                    <div className="flex flex-col text-[#5C5C5C] gap-2">
                      <label className="md:-mb-[6px]">{t("permission")}</label>

                      <SelectBox
                        name="store_user_type_id"
                        placeholder={t("select")}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={
                          // contractType === "Cashier_Ecom"
                          //   ?
                          formik.values.store_user_type_id
                          // : contractType === "Cashier"
                          // ? 2
                          // : 1
                        }
                        touched={formik.touched.store_user_type_id}
                        error={formik.errors.store_user_type_id}
                        options={[
                          { value: "", label: t("select") },
                          ...userTypes?.map((item) => ({
                            value: item?.id,
                            label: t(item?.name),
                          })),
                        ]}
                        disabled={isEdit}
                      />
                    </div>
                  )}
                        <div className="flex flex-col gap-2">
                          <label style={{ marginBottom: -6 }}>{t("Username")}</label>
  <InputBox
    name="username"
    placeholder={t("Enter Username")}
    onChange={(e) => {
      e.target.value = e.target.value.replace(/@/g, "");
      formik.handleChange(e);
      setHasChanges(true);
    }}
    onBlur={formik.handleBlur}
    value={formik.values.username}
    touched={formik.touched.username}
    error={formik.errors.username}
  />
                  </div>
                   {allStores && (
                      <div className="flex flex-col text-[#5C5C5C] gap-2">
                        <label className="mb-1">{t("Store")}</label>
                        <Select
                          style={{ width: "100%" }}
                          placeholder={t("Select Store")}
                          className="h-10"
                          value={selectedSubStore || ""}
                          onChange={(value) => {
                            setSelectedSubStore(value);
                            setHasChanges(true);
                          }}
                          showSearch
                          disabled={isEdit}
                        >
                          <Select.Option
                            key={masterStore?.store_id}
                            value={masterStore?.store_id}
                          >
                            {i18next.language === "ar"
                              ? masterStore?.store_name_ar
                              : masterStore?.store_name}
                          </Select.Option>
                          {subStores?.map((store) => (
                            <Select.Option
                              key={store.store_id}
                              value={store.store_id}
                            >
                              {i18next.language === "ar"
                                ? store.store_name_ar
                                : store.store_name}
                            </Select.Option>
                          ))}
                        </Select>
                      </div>
                    )}
                    {userinfo?.is_master_store && (formik.values.store_user_type_id == 1 ||
                    isEdit?.user_type === "online_sale") && isEdit?.user_type !== "admin" && <>
                     <label className="-mb-3">{t("Stores Access")}</label>
                    <MultiSelectBox
                    // label={t("Stores Access")}
                    name="groups"
                    value={storesAccess}
                    onChange={(event) => {
                      const value = event.target.value;
                      setStoresAccess(value);
                       setHasChanges(true);
                      // if (value?.length > 0 && fromType) {
                      //   fetchBalance(fromType, value);
                      // }
                    }}
                    placeholder={t("Select")}
                    // defaultValue={masterStore?.store_id}
                   options={[
  ...subStores
    ?.filter((item) => item?.active) // only active stores
    .map((item) => ({
      value: item?.store_id,
      label:
        i18n.language === "ar"
          ? item.store_name_ar
          : item.store_name,
    })),
]}
                    // disabled={!isProductSelected}
                  />
                     </>
                  }
                 
                 
                </div>

                <div className="w-full flex flex-col  leading-[0px] gap-4">
                  {/* <div> */}
                  <div
                    className="flex items-center justify-between"
                    style={{ marginBottom: -15, marginTop: 15 }}
                  >
                    <label>{t("email")}</label>
                    {/* {isValidEmailFormat(formik.values.email) && (
                      <span className="-my-2">
                        {isEmailVerified ? (
                          <span className="flex items-center gap-1 text-green-600 text-xs font-semibold">
                            <FaCheckCircle /> {t("Verified")}
                          </span>
                        ) : (
                          <span
                            className="text-primaryBlue text-xs font-semibold cursor-pointer"
                            onClick={() => handleSendOtp("email")}
                          >
                            {t("verify")}
                          </span>
                        )}
                      </span>
                    )} */}
                  </div>
                  <InputBox
                    name="email"
                    placeholder={t("enter_email")}
                    onChange={(e) => {
                      formik.handleChange(e);
                      setError(0);
                      setHasChanges(true);
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                    touched={formik.touched.email}
                    error={formik.errors.email}
                    autoComplete="new-email"
                    // disabled={isEdit?.user_type === "admin"}
                  />
                  {Error == 1 && (
                    <div className="text-xs text-red">
                      {" "}
                      {t("Email already registered")}
                    </div>
                  )}
                  {/* </div> */}
                  <div
                    
                    className="flex flex-col text-[#5C5C5C] gap-2"
                  >
                    {/* <div className="relative mb-[2px]">
                      <label>{t("Mobile Number")}</label>
                      {/^\d{10,15}$/.test(normalizedPhone) && (
                        <span className="absolute right-0 -top-2">
                          {isPhoneVerified ? (
                            <span className="flex items-center gap-1 text-green-600 text-xs font-semibold">
                              <FaCheckCircle /> {t("Verified")}
                            </span>
                          ) : (
                            <span
                              className="text-primaryBlue text-xs font-semibold cursor-pointer"
                              onClick={() => handleSendOtp("phone")}
                            >
                              {t("verify")}
                            </span>
                          )}
                        </span>
                      )}
                    </div> */}
                      <div
                    className="flex items-center justify-between"
                    style={{ marginTop: 3,marginBottom:1 }}
                  >
                    <label>{t("Mobile Number")}</label>
                    {/* {/^\d{10,15}$/.test(normalizedPhone) && (
                      <span className="-my-2">
                        {isPhoneVerified ? (
                          <span className="flex items-center gap-1 text-green-600 text-xs font-semibold">
                            <FaCheckCircle /> {t("Verified")}
                          </span>
                        ) : (
                          <span
                            className="text-primaryBlue text-xs font-semibold cursor-pointer"
                            onClick={() => handleSendOtp("phone")}
                          >
                            {t("verify")}
                          </span>
                        )}
                      </span>
                    )} */}
                  </div>
                    <div 
                    style={{ direction: "ltr" }}
                    className="flex flex-row">
                      <div className="h-10 w-16 text-md text-body outline-none focus:outline-none  rounded-md border p-3 flex items-center justify-center">
                        <img src={FlagIcon} height={50} width={50} alt="img" />
                      </div>
                      <Input
                        type="tel"
                        placeholder={t("01-xxxxxxxx")}
                        value={formik.values.phoneNumber}
                        onChange={(e) => {
                          const value = e.target.value;

                          // allow empty value (for backspace)
                          if (value === "" || /^[0-9]*$/.test(value)) {
                            formik.setFieldValue("phoneNumber", value);
                            setHasChanges(true);
                          }
                        }}
                        onBlur={formik.handleBlur}
                        name="phoneNumber"
                        maxLength={getMaxLength(formik?.values.phoneNumber)}
                        className={`h-10 w-100 ms-2 text-md text-body outline-none focus:outline-none ltr:pl-5 rtl:pr-5 rounded-md border p-3 ${
                          formik.touched.phoneNumber &&
                          formik.errors.phoneNumber
                            ? "border-red" // Apply red border when touched or notification shown
                            : ""
                        }`}
                        // disabled={isEdit?.user_type === "admin"}
                      />
                    </div>
                     <div className="flex flex-col gap-2 mt-2">
                    <label  style={{ marginBottom: -6 }}>{t("Password")}</label>
                    <Password
                      loc="0"
                      height={'h-[42px]'}
                      name="password"
                      placeholder={t("Enter Password")}
                      maxLength={20}
                      onChange={(e) => {
                        formik.handleChange(e);
                        setHasChanges(true);
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.password}
                      error={formik.errors.password}
                      touched={formik.touched.password}
                      autoComplete="new-email"
                      // disabled={isEdit?.user_type === "admin"}
                    />
                </div>
                 {(formik.values.store_user_type_id == 1 ||
                    isEdit?.user_type === "online_sale") && (
                    <div>
{isEdit?.user_type != "admin" && 
 <div className="flex items-center gap-x-2 -mb-1 mt-1 ms-1">
                        <input
                          type="checkbox"
                          className="  cursor-pointer scale-125"
                          checked={formik.values.is_show_cost_price}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            formik.setFieldValue(
                              "is_show_cost_price",
                              checked,
                            );
                            setHasChanges(true);
                          }}
                        />
                        <label className="text-base">
                          {t("Show cost price on inventory")}
                        </label>
                      </div>}
                     
                    </div>
                    
                  )}
                      {/* <label style={{ marginBottom: -6 }}>{t("Username")}</label>
  <InputBox
    name="username"
    placeholder={t("Enter Username")}
    onChange={(e) => {
      formik.handleChange(e);
      setHasChanges(true);
    }}
    onBlur={formik.handleBlur}
    value={formik.values.username}
    touched={formik.touched.username}
    error={formik.errors.username}
  /> */}
                  
                   
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      {popup && (
        <UsermanagementPopup
          isSuccess={isSuccess}
          message={message}
          close={() => {
            setIsSuccess(false);
            setpopup(false);
            onClose();
          }}
        />
      )}
      {/* <VerifyContactOtp
        isOpen={!!otpModal}
        onClose={() => setOtpModal(null)}
        title={otpModal === "email" ? t("verify_email") : t("verify_phone_number")}
        description={
          otpModal === "email"
            ? `${t("otp_sent_email_msg")} ${normalizedEmail}`
            : `${t("otp_sent_msg")} ${normalizedPhone}`
        }
        numeric={otpModal !== "email"}
        onResend={handleResendOtp}
        onSubmitOtp={handleSubmitOtp}
        onVerified={handleOtpVerified}
      /> */}
    </div>
  );
};

export default AddUser;
